import { useSelector } from "react-redux";
import { FaCrown } from "react-icons/fa";
import capitalize from "antd/es/_util/capitalize";
import { dateString, formatDate } from "../utility/helper";

const plansName = {
  pro: "Pro",
  lite: "Lite",
  enterprise: "Enterprise",
};

const useSubscriptionPlans = () => {
  const {
    profile: { profileData = {}, loading },
  } = useSelector((state) => state);

  const { current_pricing_plan: planData = {} } = profileData;

  const {
    title,
    frequency,
    exp_date: endDate,
    plan,
    plan_detail: planDetail = {},
  } = planData;

  const hasSubscription = plan !== "None" && plan !== "service_based";
  const isServiceBased = plan === "service_based";
  const planTitle = title === "free" ? "Free Trial" : plansName?.[title];
  const iconColor =
    planTitle === "Lite"
      ? "#CD7F32"
      : planTitle === "Pro"
        ? "#C0C0C0"
        : "#FFD700";

  const isEnterprise = title === "enterprise";

  const expirationDate =
    endDate !== "None" ? dateString(endDate) : null;

  const subscriptionName = hasSubscription ? capitalize(title) : null;

  const subscriptionData = {
    id: planDetail?.id || "",
    isCanceled: planDetail?.canceled_at,
    endDate: isEnterprise
      ? dateString(endDate)
      : dateString(planDetail?.current_period_end),
    startDate: isEnterprise
      ? null
      : dateString(planDetail?.current_period_start),
    amount: planDetail?.amount || null,
    interval: isEnterprise
      ? null
      : planDetail?.interval === "year"
        ? "Annual"
        : "Monthly",
    planType: !isEnterprise
      ? `${planDetail?.canceled_at ? "Canceled" : "Active"}, ${
          planDetail?.interval === "year" ? "Annual" : "Monthly"
        }`
      : null,
    periodEnd: planDetail?.current_period_end,
    periodStart: planDetail?.current_period_start,
    planMode: !isEnterprise
      ? planDetail?.interval === "year"
        ? `yearly_${title}`
        : `monthly_${title}`
      : null,
  };

  const proColor = "#C0C0C0";
  const basicColor = "#CD7F32";
  const enterpriseColor = "#FFD700";

  const basicIcon = <FaCrown color={basicColor} />;
  const proIcon = <FaCrown color={proColor} />;
  const enterpriseIcon = <FaCrown color={enterpriseColor} />;

  const isActive = hasSubscription && !planDetail?.canceled_at;
  // const nextChargeDate = subscriptionData?.periodEnd
  //   ? formatDate(new Date(subscriptionData?.periodEnd * 1000), false)
  //   : null;

  return {
    hasPlan: hasSubscription,
    basicIcon,
    proIcon,
    proColor,
    basicColor,
    planTitle,
    isServiceBased,
    iconColor,
    hasSubscription,
    enterpriseIcon,
    enterpriseColor,
    subscriptionData,
    expirationDate,
    subscriptionName,
    isLoading: loading,
    isEnterprise,
    isActive,
  };
};

export default useSubscriptionPlans;
